export interface ProgressiveDisclosureOption {
  id: string;
  label: string;
  prompt: string;
}

export interface ProgressiveDisclosureCategory {
  id: string;
  label: string;
  options: Array<ProgressiveDisclosureOption>;
}

export const PROGRESSIVE_DISCLOSURE_CATEGORIES: Array<ProgressiveDisclosureCategory> = [
  {
    id: 'capture-data',
    label: 'Capture data',
    options: [
      {
        id: 'register-entities',
        label: 'Register entities from file',
        prompt:
          'I want to import entities into Benchling. Please ask me one or two questions to determine what entities need to be registered and any context on the data source to assist with registration. Then generate a draft entry with the appropriate registration tables for data capture.',
      },
      {
        id: 'import-results',
        label: 'Import results from file',
        prompt:
          'I want to import results into Benchling. Please ask me one or two questions to determine what results need to be created and any context on the data source to assist with import. Then generate a draft entry with the appropriate result tables for data capture.',
      },
      {
        id: 'create-notebook-entry',
        label: 'Create and fill a notebook entry',
        prompt:
          'I want to draft a notebook entry using AI. Start a draft prefilled with placeholder sections for a standard notebook entry and ask me one or two questions to determine what the purpose of the entry is, if it should follow a specific template, and any other specific needs for its structure.',
      },
    ],
  },
  {
    id: 'analyze-data',
    label: 'Analyze data',
    options: [
      {
        id: 'statistical-analysis',
        label: 'Run statistical analysis on data',
        prompt:
          'I want to run statistical analyses on my data. Find my most recently captured results and suggest analyses I can run for that data. Then ask me one or two questions to confirm the type of statistical analysis and which data it should be run on.',
      },
      {
        id: 'chart-results',
        label: 'Chart and plot results',
        prompt:
          'I want to plot and chart my result data. Briefly review recently captured results and suggest a chart based on this data. Ask me one or two questions to confirm what type of charts or plots are needed and which result data it should be run on.',
      },
      {
        id: 'qc-check',
        label: 'QC check my data',
        prompt:
          "I want to do QC checks on my recently captured data. Please ask me one or two questions to determine which data I'm interested in QC checking and any specific QC requirements I'm trying to compare against.",
      },
    ],
  },
  {
    id: 'write-reports',
    label: 'Write reports',
    options: [
      {
        id: 'experimental-report',
        label: 'Write a lab report',
        prompt:
          'I want to write a lab report on my recent work. Please ask me one or two questions to determine what the report should be on, and any requirements there are for format, content or style.',
      },
      {
        id: 'regulatory-report',
        label: 'Write a regulatory report',
        prompt:
          "I want to write a regulatory report on the programs or projects I've been involved in. Please ask me one or two questions to determine the specific type of regulatory report needed, and confirm the scope and topic.",
      },
      {
        id: 'status-report',
        label: 'Write a status report',
        prompt:
          'I want to write a status report based on my recent work. Offer a suggestion for what this report could contain and ask me one or two questions to confirm the scope of the report and its intended audience.',
      },
    ],
  },
];
